import React, { useEffect, useState } from "react";
import "../movieList/movieList.css";
import { useParams } from "react-router-dom";
import Cards from "../card/card";

const Releaseyear = () => {
    const [movieList, setMovieList] = useState([]);
    const [selectedYear, setSelectedYear] = useState("");
    const [years, setYears] = useState([]); // State to store the available release years
    const [page, setPage] = useState(1); // Track current page
    const [totalPages, setTotalPages] = useState(1); // Track total pages
    const { release_year } = useParams(); // Change genre to release_year

    useEffect(() => {
        fetchYears();
    }, []); // Fetch available release years when component mounts

    useEffect(() => {
        if (release_year) {
            setSelectedYear(release_year);
            setPage(1); // Reset page when release year changes
            getData(release_year, 1);
        }
    }, [release_year]); // Trigger getData whenever the release_year changes

    const fetchYears = () => {
        const currentYear = new Date().getFullYear();
        const startYear = 1920; // Start year
        const yearsArray = Array.from({ length: currentYear - startYear + 1 }, (_, index) => currentYear - index);
        setYears(yearsArray);
    }

    const getData = (selectedYear, page) => {
        fetch(`https://api.themoviedb.org/3/discover/movie?api_key=4e44d9029b1270a757cddc766a1bcb63&language=en-US&primary_release_year=${selectedYear}&page=${page}`)
            .then(res => res.json())
            .then(data => {
                setMovieList(prevMovies => [...prevMovies, ...data.results]); // Append new data to existing movie list
                setTotalPages(data.total_pages); // Update total pages
            })
            .catch(error => console.error("Error fetching movie data:", error));
    }

    const handleYearChange = (event) => {
        const selectedYear = event.target.value;
        setSelectedYear(selectedYear);
        setPage(1); // Reset page when year changes
        setMovieList([]); // Clear movie list when year changes
        getData(selectedYear, 1);
    };

    const handleLoadMore = () => {
        const nextPage = page + 1;
        if (nextPage <= totalPages) {
            setPage(nextPage);
            getData(selectedYear, nextPage);
        }
    };

    return (
        <div className="movie__list">
            <h2 className="list__title">{selectedYear.toUpperCase()}</h2>
            <div className="genre-dropdown text-center mb-4"> {/* Reuse the same class "genre-dropdown" */}
                <select value={selectedYear} onChange={handleYearChange} className="form-select" style={{ width: "200px", margin: "auto" }}>
                    <option value="">Select Release Year</option>
                    {years.map((year, index) => (
                        <option key={index} value={year}>
                            {year}
                        </option>
                    ))}
                </select>
            </div>
            <div className="list__cards">
                {movieList.map((movie, index) => (
                    <Cards key={movie.id} movie={movie} index={index} />
                ))}
            </div>
            {page < totalPages && (
                <div className="text-center">
                    <button className="btn btn-primary" style={{backgroundColor:"white",color:"black"}} onClick={handleLoadMore}>Load More</button>
                </div>
            )}
        </div>
    )
}

export default Releaseyear;
